import { shopApiFragment } from "@saleor/fragments/shopapi";
import makeQuery from "@saleor/hooks/makeQuery";
import gql from "graphql-tag";

import { TypedQuery } from "../../queries";
import { ShopApis } from "./types/ShopApis";
import { ShopInfo } from "./types/ShopInfo";
import { ShopInfo2 } from "./types/ShopInfo2";

const shopInfo = gql`
  query ShopInfo {
    shop {
      allCountries {
        country
        code
        regions {
          code
          name
        }
      }
      countries {
        code
        country
        regions {
          code
          name
        }
      }
      defaultCountry {
        code
        country
      }
      defaultCurrency
      defaultWeightUnit
      displayGrossPrices
      domain {
        host
        url
      }
      languages {
        code
        language
      }
      includeTaxesInPrices
      name
      trackInventoryByDefault
      permissions {
        code
        name
      }
    }
  }
`;
export const TypedShopInfoQuery = TypedQuery<ShopInfo, {}>(shopInfo);

export const shopapisList = gql`
  ${shopApiFragment}
  query ShopApis {
    shopApis {
      ...ShopApiFragment
    }
  }
`;

export const useShopApisList = makeQuery<ShopApis, {}>(shopapisList);

export const getLng = gql`
  query ShopInfo2 {
    shop {
      languages {
        code
        language
      }
    }
  }
`;
export const useGetLng = makeQuery<ShopInfo2, {}>(getLng);
